import React, { useState } from 'react';
import './DevForm.css';
import PriceGuideToaster from './components/PriceGuideToaster';
import './components/PriceGuideToaster.css';

const DevForm: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    fetch('/', {
      method: 'POST',
      body: data,
    })
      .then(() => setSubmitted(true))
      .catch((error) => alert('Error submitting form: ' + error));
  };
  


  if (submitted) {
    return (
      <div className="toast-message">
        <h2>Thank you!</h2>
        <p>Your questionnaire has been submitted. We'll get back to you shortly.</p>
      </div>
    );
  }

  return (
    <div className="dev-form-container">
      <h1 className="form-heading">Website Design – Client Questionnaire</h1>
      <PriceGuideToaster /> {/* 👈 This is your toaster component */}

      <form
        name="dev-contact"
        method="POST"
        data-netlify="true"
        onSubmit={handleSubmit}
        className="dev-form"
      >
        <input type="hidden" name="form-name" value="dev-contact" />

        <label >Your Name</label>
        <input type="text" name="name" required />

        <label>Email Address</label>
        <input type="email" name="email" required />

        <label>What’s your website’s current URL?</label>
        <input type="url" name="current-website" />

        <label>What is the primary goal of your author website?</label>
        <textarea name="primary-goal" rows={4} required />

        <label>Describe your target audience</label>
        <textarea name="audience" rows={3} />

        <label>Which features do you want on the site? (e.g., blog, store, email list, calendar)</label>
        <textarea name="features" rows={3} />

        <label>List 3 websites you admire and why</label>
        <textarea name="inspiration" rows={4} />

        <label>Do you already have branding (logo, colors, fonts)?</label>
        <textarea name="branding" rows={3} />

        <label>What tone or vibe do you want the site to convey?</label>
        <textarea name="tone" rows={3} />

        <label>How many books or projects will be featured?</label>
        <input type="number" name="books-featured" />

        <label>Do you want each book/project to have a separate page?</label>
        <textarea name="book-pages" rows={3} />

        <label>Do you plan to blog or post updates?</label>
        <textarea name="blog-plan" rows={3} />

        <label>Do you want to sell books/merch directly?</label>
        <textarea name="sell-direct" rows={3} />

        <label>Do you need email list sign-up integration?</label>
        <textarea name="email-integration" rows={3} />

        <label>Do you want contact forms or booking features?</label>
        <textarea name="forms-booking" rows={3} />

        <label>Do you want a calendar for events?</label>
        <textarea name="calendar" rows={3} />

        <label>Do you want social media integration?</label>
        <textarea name="social-media" rows={3} />

        <label>Do you want blog/press kit/media kit sections?</label>
        <textarea name="press-kit" rows={3} />

        <label>Preferred deadline or launch date?</label>
        <input type="text" name="deadline" />

        <label>Budget (rough range)?</label>
        <input type="text" name="budget" />

        <label>Do you already own your domain & hosting?</label>
        <textarea name="domain-hosting" rows={3} />

        <label>Do you need ongoing support or training?</label>
        <textarea name="support-training" rows={3} />

        <label>Any legal/disclaimer/privacy needs?</label>
        <textarea name="legal" rows={3} />

        <label>Anything else you’d like to add?</label>
        <textarea name="other-info" rows={4} />

        <button type="submit">Submit Questionnaire</button>
      </form>
      
    </div>
  );
};

export default DevForm;
